import React, { useState } from 'react'
import {
  FiFileText, FiBriefcase, FiLock, FiShoppingCart, FiCreditCard,
  FiTruck, FiCornerUpLeft, FiDollarSign, FiShield, FiEdit3,
  FiPhone, FiMail, FiMapPin, FiInstagram, FiInfo, FiClock, FiHeadphones,
  FiChevronLeft,
} from 'react-icons/fi'

const SECTIONS = [
  { id: 'terms',    title: 'شرایط استفاده',              Icon: FiFileText },
  { id: 'seller',   title: 'اطلاعات فروشنده',            Icon: FiBriefcase },
  { id: 'privacy',  title: 'حریم خصوصی',                 Icon: FiLock },
  { id: 'order',    title: 'نحوه ثبت سفارش',             Icon: FiShoppingCart },
  { id: 'payment',  title: 'شیوه‌های پرداخت',             Icon: FiCreditCard },
  { id: 'shipping', title: 'رویه ارسال سفارش',           Icon: FiTruck },
  { id: 'return',   title: 'رویه بازگرداندن کالا',       Icon: FiCornerUpLeft },
  { id: 'refund',   title: 'نحوه استرداد وجه',           Icon: FiDollarSign },
  { id: 'warranty', title: 'ضمانت و خدمات پس از فروش',   Icon: FiShield },
  { id: 'dispute',  title: 'حل اختلافات و شکایات',       Icon: FiShield },
  { id: 'changes',  title: 'تغییر قوانین',               Icon: FiEdit3 },
]

function Rule() {
  const [active, setActive] = useState('terms')

  const scrollTo = (id) => {
    setActive(id)
    const el = document.getElementById(id)
    if (el) {
      const y = el.getBoundingClientRect().top + window.pageYOffset - 100
      window.scrollTo({ top: y, behavior: 'smooth' })
    }
  }

  return (
    <div dir="rtl" className="min-h-screen bg-[#F7F9F4] text-gray-800 leading-8 pb-20 font-[Vazirmatn,Tahoma,sans-serif]">
      <div className="relative overflow-hidden bg-gradient-to-l from-[#9EAD8C] via-[#8A9A7B] to-[#6F7D62] text-white py-16 px-5">
        <div className="absolute -top-24 -left-24 w-72 h-72 bg-white/10 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-24 -right-24 w-72 h-72 bg-white/10 rounded-full blur-3xl"></div>

        <div className="relative max-w-6xl mx-auto text-center">
          <h1 className="text-3xl md:text-5xl font-extrabold mb-4 tracking-tight">
            قوانین، مقررات و شرایط استفاده
          </h1>
          <p className="text-sm md:text-base opacity-95 max-w-2xl mx-auto leading-7">
            لطفاً پیش از ثبت سفارش، این صفحه را به‌طور کامل مطالعه فرمایید. با ثبت سفارش، شما تمامی این قوانین را می‌پذیرید.
          </p>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 md:px-6 -mt-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-[280px_1fr] gap-6">
          <aside className="lg:sticky lg:top-6 h-fit bg-white rounded-2xl shadow-lg shadow-[#9EAD8C]/10 p-5 border border-[#EEF3E8]">
            <h3 className="text-sm font-bold text-[#6F7D62] mb-4 flex items-center gap-2">
              <span className="w-1 h-5 bg-[#9EAD8C] rounded"></span>
              فهرست مطالب
            </h3>
            <nav className="space-y-1 max-h-[60vh] overflow-y-auto pl-1">
              {SECTIONS.map(({ id, title, Icon: Ico }) => (
                <button
                  key={id}
                  onClick={() => scrollTo(id)}
                  className={`w-full text-right flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm transition-all duration-200 ${
                    active === id
                      ? 'bg-gradient-to-l from-[#9EAD8C] to-[#8A9A7B] text-white shadow-md shadow-[#9EAD8C]/30'
                      : 'text-gray-600 hover:bg-[#F7F9F4] hover:text-[#6F7D62]'
                  }`}
                >
                  <Ico className="w-4 h-4 shrink-0" />
                  <span className="flex-1">{title}</span>
                  {active === id && <FiChevronLeft className="w-4 h-4 opacity-80" />}
                </button>
              ))}
            </nav>
          </aside>

          <main className="bg-white rounded-2xl shadow-lg shadow-[#9EAD8C]/10 p-6 md:p-10 border border-[#EEF3E8]">
            <Section id="terms" Icon={FiFileText} title="شرایط استفاده">
              <p>
                استفاده از خدمات وب‌سایت <b className="text-[#6F7D62]">اریس گالری</b> به معنی پذیرش کامل قوانین و مقررات ذیل است.
                این قوانین مطابق با <b>قانون تجارت الکترونیکی ایران</b> و <b>قانون حمایت از حقوق مصرف‌کننده</b> تنظیم شده است.
              </p>
              <p>
                وب‌سایت اریس گالری یک بستر اینترنتی برای معرفی، فروش و ارسال محصولات چوبی است. استفاده‌کننده با ثبت سفارش،
                تأیید می‌کند که تمامی اطلاعات وارد شده توسط وی صحیح و مطابق با واقعیت است. مسئولیت صحت اطلاعات وارد شده
                بر عهده کاربر می‌باشد.
              </p>
              <p>
                فروشنده حق دارد در هر زمان، بدون اطلاع قبلی، دسترسی کاربران به سایت را محدود یا مسدود نماید؛ به‌ویژه در
                صورت مشاهده هرگونه تخلف، سوءاستفاده یا ورود اطلاعات نادرست.
              </p>
              <p>
                در صورت بروز هرگونه تغییر در قوانین، اطلاع‌رسانی از طریق همین صفحه انجام خواهد شد و ادامه استفاده از سایت
                به معنی پذیرش نسخه به‌روز قوانین است.
              </p>
            </Section>

            <Section id="seller" Icon={FiBriefcase} title="اطلاعات فروشنده">
              <p className="mb-4">
                مطابق با الزامات قانون تجارت الکترونیکی و دستورالعمل‌های اینماد، اطلاعات هویتی و ارتباطی فروشنده
                به شرح زیر اعلام می‌گردد:
              </p>
              <div className="grid sm:grid-cols-2 gap-4 mt-4">
                <InfoCard Icon={FiBriefcase}  label="نام کسب‌وکار"    value="مجموعه تولیدی اریس گالری" />
                <InfoCard Icon={FiInfo}       label="نوع فعالیت"      value="حقیقی" />
                <InfoCard Icon={FiPhone}      label="تلفن پشتیبانی"   value="09903607525" ltr />
                <InfoCard Icon={FiMail}       label="ایمیل"           value="ErissWood@gmail.com" ltr />
                <InfoCard Icon={FiInstagram}  label="اینستاگرام"      value="@Eriss_Wood" ltr />
                <InfoCard Icon={FiMapPin}     label="نشانی"           value="مشهد، بلوار طرحچی، طرحچی ۳۲، خیابان صنعت، مجموعه تولیدی اریس گالری" full />
              </div>
              <div className="bg-gradient-to-l from-[#EEF3E8] to-white border-r-4 border-[#9EAD8C] rounded-xl px-5 py-4 mt-5 text-sm text-[#3d4a33] flex gap-3 items-start">
                <FiInfo className="w-5 h-5 shrink-0 mt-0.5 text-[#8A9A7B]" />
                <span>ساعات پاسخگویی پشتیبانی: شنبه تا پنجشنبه، از ساعت ۹ صبح تا ۱۸ عصر.</span>
              </div>
            </Section>

            <Section id="privacy" Icon={FiLock} title="حریم خصوصی">
              <p className="mb-3">
                اریس گالری احترام به حریم خصوصی کاربران را یکی از اصول اصلی خود می‌داند و متعهد می‌شود اطلاعات شخصی
                کاربران را با بالاترین سطح امنیت حفاظت نماید.
              </p>
              <Bullet><b>اطلاعات جمع‌آوری شده:</b> نام و نام خانوادگی، شماره تماس، آدرس پستی، کد پستی و در صورت نیاز آدرس ایمیل — که صرفاً در هنگام ثبت سفارش یا ثبت‌نام دریافت می‌شود.</Bullet>
              <Bullet><b>هدف از جمع‌آوری:</b> پردازش سفارش، هماهنگی ارسال، اطلاع‌رسانی وضعیت سفارش و ارائه خدمات پس از فروش.</Bullet>
              <Bullet><b>عدم اشتراک‌گذاری:</b> اطلاعات شخصی کاربران هرگز بدون رضایت آن‌ها در اختیار شخص ثالث قرار نمی‌گیرد، مگر در مواردی که قانوناً الزام شود.</Bullet>
              <Bullet><b>کوکی‌ها:</b> سایت ممکن است از کوکی‌ها برای بهبود تجربه کاربری، نگه‌داشتن سبد خرید و تحلیل بازدیدها استفاده کند.</Bullet>
              <Bullet><b>امنیت اطلاعات:</b> کلیه اطلاعات از طریق پروتکل امن SSL منتقل شده و پردازش‌های مالی بر بستر درگاه‌های رسمی و مورد تأیید شاپرک انجام می‌شود.</Bullet>
            </Section>

            <Section id="order" Icon={FiShoppingCart} title="نحوه ثبت سفارش">
              <p>برای ثبت سفارش در اریس گالری، کاربر مراحل زیر را طی می‌کند:</p>
              <ol className="list-decimal pr-6 space-y-2 mt-3 text-[15px]">
                <li>انتخاب محصول مورد نظر و افزودن آن به سبد خرید.</li>
                <li>ورود به صفحه تسویه حساب و تکمیل اطلاعات گیرنده (نام، شماره تماس و آدرس دقیق).</li>
                <li>مشاهده <b>پیش‌فاکتور</b> شامل مشخصات کالا، مبلغ، هزینه ارسال و جمع کل.</li>
                <li>تأیید پیش‌فاکتور و انتخاب شیوه پرداخت.</li>
                <li>پرداخت مبلغ و دریافت کد رهگیری سفارش.</li>
              </ol>
            </Section>

            <Section id="payment" Icon={FiCreditCard} title="شیوه‌های پرداخت">
              <Bullet>پرداخت آنلاین از طریق کلیه کارت‌های بانکی عضو شبکه شتاب و از طریق درگاه‌های رسمی و مورد تأیید شاپرک.</Bullet>
              <Bullet>پرداخت در محل (فقط در محدوده جغرافیایی مشخص و برای برخی محصولات)، به‌صورت نقدی یا با کارت‌خوان سیار.</Bullet>
              <Bullet>امکان پرداخت اعتباری و اقساطی در صورت فراهم بودن شرایط، متعاقباً اطلاع‌رسانی خواهد شد.</Bullet>
              <div className="bg-gradient-to-l from-[#EEF3E8] to-white border-r-4 border-[#9EAD8C] rounded-xl px-5 py-4 my-4 text-sm text-[#3d4a33] flex gap-3 items-start">
                <FiInfo className="w-5 h-5 shrink-0 mt-0.5 text-[#8A9A7B]" />
                <span>هیچ‌گونه پرداخت خارج از سایت (کارت به کارت شخصی، رمزارز و...) مورد تأیید اریس گالری نیست.</span>
              </div>
            </Section>

            <Section id="shipping" Icon={FiTruck} title="رویه ارسال سفارش">
              <p className="mb-3">
                ارسال سفارشات اریس گالری با همکاری شرکت‌های پست و باربری معتبر انجام می‌شود.
              </p>
              <Bullet><b>زمان آماده‌سازی سفارش:</b> بین ۱ تا ۳ روز کاری پس از تأیید پرداخت.</Bullet>
              <Bullet><b>زمان تحویل:</b> بین ۲ تا ۵ روز کاری بسته به مقصد و نوع ارسال.</Bullet>
              <Bullet><b>هزینه ارسال:</b> پیش از تأیید نهایی سفارش، به‌طور شفاف در پیش‌فاکتور نمایش داده می‌شود.</Bullet>
              <Bullet><b>رهگیری سفارش:</b> کد رهگیری مرسوله پس از ارسال، از طریق سایت  قابل مشاهده است .</Bullet>
              <Bullet>در صورت بروز تأخیر غیرمنتظره، موضوع از طریق پیامک یا تماس تلفنی اطلاع داده خواهد شد.</Bullet>
              <Bullet>در صورت عدم تحویل مرسوله به هر دلیل از سمت مشتری، هزینه ارسال مجدد بر عهده مشتری خواهد بود.</Bullet>
            </Section>

            <Section id="return" Icon={FiCornerUpLeft} title="رویه بازگرداندن کالا">
              <p className="mb-3">
                مطابق با <b>ماده ۳۷ قانون تجارت الکترونیکی ایران</b> و دستورالعمل‌های سازمان حمایت از مصرف‌کننده،
                مشتری حق دارد ظرف مدت <b>۷ روز کاری</b> از تاریخ دریافت کالا، بدون ذکر دلیل، از خرید خود انصراف دهد.
              </p>
              <p className="mb-3"><b>شرایط مرجوعی کالا:</b></p>
              <Bullet>کالا باید در بسته‌بندی اصلی، سالم و بدون آسیب فیزیکی باشد.</Bullet>
              <Bullet>همراه کالا، تمامی متعلقات، اتیکت‌ها و لوازم جانبی ارسال شود.</Bullet>
              <Bullet>کاربر موظف است پیش از ارسال، با پشتیبانی تماس گرفته و کد پیگیری مرجوعی دریافت کند.</Bullet>
              <Bullet>هزینه ارسال مرجوعی در صورت عدم وجود ایراد فنی، بر عهده مشتری است.</Bullet>
              <p className="mb-3 mt-4"><b>موارد استثنا (غیرقابل مرجوعی):</b></p>
              <Bullet>کالاهای سفارشی‌سازی‌شده یا تولیدی به سفارش مشتری.</Bullet>
              <Bullet>کالاهای فسادپذیر یا آسیب‌پذیر.</Bullet>
              <Bullet>محصولاتی که مهر و پلمب آن‌ها باز شده باشد.</Bullet>
              <div className="bg-gradient-to-l from-[#EEF3E8] to-white border-r-4 border-[#9EAD8C] rounded-xl px-5 py-4 my-4 text-sm text-[#3d4a33] flex gap-3 items-start">
                <FiInfo className="w-5 h-5 shrink-0 mt-0.5 text-[#8A9A7B]" />
                <span>در صورت دریافت کالای آسیب‌دیده یا مغایر با سفارش، حداکثر تا <b>۲۴ ساعت</b> پس از تحویل با پشتیبانی تماس بگیرید.</span>
              </div>
            </Section>

            <Section id="refund" Icon={FiDollarSign} title="نحوه استرداد وجه">
              <p>
                در صورت تأیید درخواست مرجوعی توسط کارشناسان اریس گالری، مبلغ پرداختی حداکثر ظرف
                <b> ۷۲ ساعت کاری </b>به یکی از روش‌های زیر به مشتری بازگردانده می‌شود:
              </p>
              <Bullet><b>پرداخت آنلاین:</b> واریز به شماره کارت یا شماره شبا اعلامی از سوی مشتری (به نام خودِ مشتری).</Bullet>
              <Bullet><b>پرداخت در محل:</b> بازگشت وجه به‌صورت نقدی در محل یا واریز به شماره کارت مشتری.</Bullet>
              <Bullet>در صورت تمایل، مشتری می‌تواند مبلغ را به‌عنوان <b>اعتبار خرید</b> در حساب کاربری خود دریافت کند.</Bullet>
              <p className="mt-4">
                توجه داشته باشید که در برخی موارد، بسته به شرایط بانکی، زمان واریز مبلغ ممکن است تا ۷۲ ساعت کاری پس از
                تأیید مرجوعی به طول بیانجامد.
              </p>
            </Section>

            <Section id="warranty" Icon={FiShield} title="ضمانت و خدمات پس از فروش">
              <p className="mb-3">
                کلیه محصولات ارائه‌شده در اریس گالری، مطابق با شرایط درج‌شده در صفحه هر محصول، دارای
                <b> ضمانت اصالت و سلامت فیزیکی </b>هستند.
              </p>
              <Bullet>ضمانت اصالت کالا: در صورت اثبات عدم اصالت، مبلغ به‌طور کامل بازگردانده می‌شود.</Bullet>
              <Bullet>ضمانت سلامت فیزیکی: در صورت وجود هرگونه ایراد فنی در زمان تحویل، کالا به‌طور رایگان تعویض می‌شود.</Bullet>
              <Bullet>خدمات پس از فروش شامل مشاوره نگهداری، تعمیرات احتمالی و تأمین قطعات، بر عهده فروشنده یا شرکت همکار است.</Bullet>
              <Bullet>مدت زمان گارانتی و شرایط دقیق آن، در صفحه هر محصول به‌طور شفاف ذکر شده است.</Bullet>
            </Section>

            <Section id="dispute" Icon={FiShield} title="حل اختلافات و رسیدگی به شکایات">
              <p className="mb-3">
                اریس گالری متعهد است در صورت بروز هرگونه اختلاف یا نارضایتی، موضوع را با اولویت و در اسرع وقت بررسی نماید.
                کاربران می‌توانند از طریق راه‌های زیر شکایت خود را ثبت کنند:
              </p>
              <div className="space-y-2 mb-4">
                <ContactRow Icon={FiPhone}     text="تماس با تلفن پشتیبانی"  value="09903607525" href="tel:09903607525" />
                <ContactRow Icon={FiMail}      text="ارسال ایمیل به"          value="ErissWood@gmail.com" href="mailto:ErissWood@gmail.com" />
                <ContactRow Icon={FiInstagram} text="پیام در اینستاگرام"      value="@Eriss_Wood" href="https://instagram.com/Eriss_Wood" />
                <ContactRow Icon={FiHeadphones} text="استفاده از فرم تماس در صفحه «تماس با ما»" />
              </div>
              <p>
                در صورت عدم حل اختلاف از طریق راه‌های فوق، موضوع از طریق
                <b> سامانه رسیدگی به شکایات اینماد </b>
                و همچنین مراجع قانونی ذی‌ربط قابل پیگیری خواهد بود.
              </p>
            </Section>

            <Section id="changes" Icon={FiEdit3} title="تغییر قوانین" last>
              <p>
                اریس گالری حق دارد در هر زمان، بدون اطلاع قبلی، این قوانین و مقررات را به‌روزرسانی یا اصلاح کند.
                نسخه معتبر همیشه آخرین نسخه منتشرشده در همین صفحه در وب‌سایت خواهد بود. کاربران موظف‌اند
                پیش از هر خرید، این صفحه را مطالعه نمایند. ادامه استفاده از سایت پس از اعمال تغییرات به معنی
                پذیرش نسخه جدید قوانین است.
              </p>
            </Section>
          </main>
        </div>

        <div className="relative overflow-hidden mt-8 bg-gradient-to-l from-[#9EAD8C] via-[#8A9A7B] to-[#6F7D62] text-white rounded-2xl px-6 md:px-10 py-8 shadow-xl shadow-[#8A9A7B]/30">
          <div className="absolute -top-10 -left-10 w-40 h-40 bg-white/10 rounded-full blur-2xl"></div>
          <div className="relative flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="text-center md:text-right">
              <h3 className="text-xl font-bold mb-2 flex items-center gap-2 justify-center md:justify-start">
                <FiHeadphones className="w-6 h-6" />
                سوالی دارید؟ ما کنار شما هستیم
              </h3>
              <p className="text-sm opacity-90">تیم پشتیبانی اریس گالری آماده پاسخگویی به شماست.</p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
              <a href="tel:09903607525"
                 className="flex items-center justify-center gap-2 bg-white text-[#6F7D62] font-bold px-5 py-3 rounded-xl hover:bg-[#F7F9F4] transition shadow-md">
                <FiPhone className="w-4 h-4" />
                <span dir="ltr">09903607525</span>
              </a>
              <a href="mailto:ErissWood@gmail.com"
                 className="flex items-center justify-center gap-2 bg-white/15 backdrop-blur border border-white/25 px-5 py-3 rounded-xl hover:bg-white/25 transition">
                <FiMail className="w-4 h-4" />
                ارسال ایمیل
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function Section({ id, Icon: Ico, title, children, last }) {
  return (
    <section id={id} className={`scroll-mt-24 ${last ? '' : 'pb-8 mb-8 border-b border-dashed border-[#EEF3E8]'}`}>
      <div className="flex items-center gap-3 mb-4">
        <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-[#9EAD8C] to-[#8A9A7B] flex items-center justify-center text-white shadow-md shadow-[#9EAD8C]/30">
          <Ico className="w-5 h-5" />
        </div>
        <h2 className="text-lg md:text-xl font-bold text-[#6F7D62]">{title}</h2>
      </div>
      <div className="text-[15px] text-gray-700 text-justify space-y-2 pr-2">
        {children}
      </div>
    </section>
  )
}

function Bullet({ children }) {
  return (
    <div className="flex items-start gap-3 py-1">
      <span className="mt-2.5 w-1.5 h-1.5 rounded-full bg-[#9EAD8C] shrink-0"></span>
      <span className="flex-1">{children}</span>
    </div>
  )
}

function InfoCard({ Icon: Ico, label, value, ltr, full }) {
  return (
    <div className={`bg-[#F7F9F4] border border-[#EEF3E8] rounded-xl px-4 py-3 hover:border-[#9EAD8C] transition flex items-start gap-3 ${full ? 'sm:col-span-2' : ''}`}>
      <div className="w-9 h-9 rounded-lg bg-white border border-[#EEF3E8] flex items-center justify-center text-[#8A9A7B] shrink-0">
        <Ico className="w-4 h-4" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-xs text-[#8A9A7B] mb-1 font-semibold">{label}</div>
        <div className={`text-sm text-gray-800 font-medium break-words ${ltr ? 'text-left' : ''}`} dir={ltr ? 'ltr' : 'rtl'}>
          {value}
        </div>
      </div>
    </div>
  )
}

function ContactRow({ Icon: Ico, text, value, href }) {
  const content = (
    <div className="flex items-center gap-3 bg-[#F7F9F4] border border-[#EEF3E8] rounded-xl px-4 py-3 hover:border-[#9EAD8C] transition">
      <div className="w-9 h-9 rounded-lg bg-white border border-[#EEF3E8] flex items-center justify-center text-[#8A9A7B] shrink-0">
        <Ico className="w-4 h-4" />
      </div>
      <div className="flex-1">
        <span className="text-sm text-gray-700">{text}</span>
        {value && (
          <>
            <span className="text-sm text-gray-700">: </span>
            <b className="text-[#6F7D62] text-sm" dir="ltr">{value}</b>
          </>
        )}
      </div>
    </div>
  )
  return href ? <a href={href} className="block">{content}</a> : content
}

export default Rule